import { http } from '@/shared/api/http'

import type {
  AdminLoginRequest,
  AdminSessionResponse,
  AdminSessionUser,
  LogoutResponse,
} from '../types'

export const authApi = {
  login: (credentials: AdminLoginRequest) =>
    http.post<AdminSessionResponse>('/auth/login', credentials),
  refresh: () => http.post<AdminSessionResponse>('/auth/refresh'),
  me: () => http.get<AdminSessionUser>('/auth/me'),
  logout: () => http.post<LogoutResponse>('/auth/logout'),
}
